let topBanner = {};

const body = document.querySelector('body');
const overlay = document.getElementById('js-overlay');
const closePopup = document.getElementById('js-close-popup');
const uspTopBannerPopup = document.getElementById('js-usp-top-banner-popup');
const uspTopBannerItems = document.querySelectorAll('.js-usp-top-banner-item');

topBanner.animate = function() {
    window.addEventListener('load', function() {
        let currentIndex = 0;
        const totalItems = uspTopBannerItems.length;

        function showItem(index) {
            uspTopBannerItems.forEach((item, i) => {
                item.classList.remove('show');
                if (i === index) {
                    item.classList.add('show');
                }
            });
        }

        function rotateItems() {
            showItem(currentIndex);
            currentIndex = (currentIndex + 1) % totalItems;
        }


		if (uspTopBannerItems.length > 0) {
			// Initialize the first item display
			showItem(currentIndex);

			// Change item every 5 seconds
			setInterval(rotateItems, 5000);
		}

    });
}

topBanner.size = function() {
    const vh = window.innerHeight / 100;
	if(uspTopBannerPopup) {
		if (uspTopBannerPopup.offsetHeight > 80 * vh) {
			uspTopBannerPopup.classList.add('is-fullscreen');
		} else {
			uspTopBannerPopup.classList.remove('is-fullscreen');
		}
	}
}

topBanner.close = function() {
    if (uspTopBannerPopup) {
        uspTopBannerPopup.classList.remove('is-open');
		if (overlay) {
			overlay.style.display = 'none';
		}
        body.classList.remove('usp-top-banner-popup-no-scroll');
        uspTopBannerPopup.classList.remove('is-fullscreen');
      }
}

topBanner.init = function() {
    if (uspTopBannerItems.length > 0) {
        uspTopBannerItems.forEach(function (button) {
            button.addEventListener('click', function (event) {
                event.preventDefault();

                if(uspTopBannerPopup) {
                    uspTopBannerPopup.classList.add('is-open');
                    if (overlay) {
                        overlay.style.display = 'block';
                    }
                    body.classList.add('usp-top-banner-popup-no-scroll');
                    topBanner.size();
                }

            });
        });
    }

	if(closePopup) {
		closePopup.addEventListener('click', topBanner.close);
	}

	if(overlay) {
        overlay.addEventListener('click', topBanner.close);
	}

    window.addEventListener('resize', window.stokpress.debounce(function () {
        topBanner.size();
    }, 500));
}

topBanner.init();
topBanner.animate();



// WEBPACK FOOTER //
// ./scripts/components/top-banner.js